import { Clinic } from './clinic'
import { CurrentOrganizationEntitlements } from './organization-entitlements'
import { PrescriptionDeliveryMethod } from './prescription-delivery-method'

export interface OrganizationProfile {
  name: string
  id: string
}

export enum FundingSource {
  PRIVATE = 'PRIVATE',
  PBS = 'PBS',
}

export interface OrganizationSetting {
  id: string
  defaultFundingSource?: FundingSource
  eRxTimeout: number
  idleTimeout: number
  enableRTPM: boolean
  enableRTPMUIRestriction: boolean
  forceEnableRTPM: boolean
  enableManagePatient: boolean
  enableUpdateOrganization: boolean
  enableHelpDocument: boolean
  enableChatbot: boolean
  enableS8Medicine: boolean
  enableRewards: boolean
  enableUsersBoard?: boolean
  enableUsersManagement?: boolean
  enableUserJoinRequest?: boolean
  enableUserInvitation?: boolean
  enableAutoBuildIntegration?: boolean
  userInvitationNeedApproval?: boolean
  requireReasonForPrescription: boolean
  enableWebhooks: boolean
  defaultPrescriptionDeliveryMethod: PrescriptionDeliveryMethod
}

export interface Organization extends OrganizationProfile {
  stripeCustomerId?: string
  hasPaymentMethod?: boolean
  clinic: Clinic
  settings: OrganizationSetting
  entitlements: CurrentOrganizationEntitlements
}
